import { render, staticRenderFns } from "./EvaluationSkillFrameworkPage.vue?vue&type=template&id=09a8a28f&"
import script from "./EvaluationSkillFrameworkPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationSkillFrameworkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports